<template>
  <button
    type="button"
    :class="[
      variant,
      {
        expanded,
        button: !inline,
        'text-button': inline,
        'button-small': small,
      },
    ]"
    :disabled="disabled || isLoading"
    :aria-busy="!disabled && isLoading"
  >
    <Spinner v-if="isLoading" />
    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script setup>
import Spinner from '@atomic-ui/spinner/Spinner';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  variant: {
    /**
     * @type {import('vue').PropType<('primary' | 'secondary' | 'emphasis')>}
     */
    type: String,
    /**
     * @param {String} value
     */
    validator(value) {
      return ['emphasis', 'primary', 'secondary'].includes(value);
    },
    default: 'emphasis',
  },
});
</script>
